// extracted by mini-css-extract-plugin
export default {"modalContent":"prompt-router-custom_modalContent__dQ2F3","message":"prompt-router-custom_message__TmNcv","placeHolderShimmer":"prompt-router-custom_placeHolderShimmer__qe-ui"};